import { MapPin, Car, DoorOpen, ExternalLink } from "lucide-react";
import { useEventContent } from "@/context/EventContentContext";

export default function Location() {
  const { event } = useEventContent();
  const mapQuery = encodeURIComponent(`${event.venue || ""} ${event.city || ""}`.trim() || "Leon Guanajuato");

  return (
    <div data-testid="location-page" className="section-pad">
      <div className="container-cg">
        <div className="overline text-[var(--brand-primary)]">Ubicación</div>
        <h1 className="font-serif-cg text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3">
          ¿Dónde nos encontramos?
        </h1>

        <div className="grid md:grid-cols-12 gap-8 mt-14">
          <div className="md:col-span-7">
            <div className="card-cg overflow-hidden aspect-[4/3] md:aspect-[16/10]">
              <iframe
                title="Mapa del evento"
                src={`https://www.google.com/maps?q=${mapQuery}&output=embed`}
                className="w-full h-full"
                loading="lazy"
              />
            </div>
            <a
              href={event.location.mapsUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="open-maps-btn"
              className="btn-primary-cg mt-5"
            >
              Abrir en Google Maps <ExternalLink size={14} />
            </a>
          </div>

          <aside className="md:col-span-5 space-y-5">
            <div className="card-cg p-6">
              <MapPin className="text-[var(--brand-primary)]" />
              <div className="overline text-[var(--brand-muted)] mt-4">Sede</div>
              <div className="font-serif-cg text-2xl mt-1">{event.venue}</div>
              <p className="text-sm text-[var(--brand-ink)]/80 mt-3 leading-relaxed">
                {event.location.addressLine}
                <br />
                {event.location.cityState}
              </p>
            </div>

            <div className="card-cg p-6">
              <DoorOpen className="text-[var(--brand-primary)]" />
              <div className="overline text-[var(--brand-muted)] mt-4">Cómo llegar</div>
              <p className="text-sm text-[var(--brand-ink)]/80 mt-2 leading-relaxed">{event.location.directions}</p>
            </div>

            <div className="card-cg p-6">
              <Car className="text-[var(--brand-primary)]" />
              <div className="overline text-[var(--brand-muted)] mt-4">Estacionamiento</div>
              <p className="text-sm text-[var(--brand-ink)]/80 mt-2 leading-relaxed">{event.location.parking}</p>
              <div className="hairline my-4" />
              <div className="overline text-[var(--brand-muted)]">Accesos</div>
              <p className="text-sm text-[var(--brand-ink)]/80 mt-2 leading-relaxed">{event.location.access}</p>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}
